import { Unicodes } from './unicodes/unicodes';

export abstract class StringUtils {
  static isBlank(val: unknown): boolean {
    if (!StringUtils.isString(val)) {
      return true;
    }

    const trimedString = val.trim();
    return trimedString.length === 0;
  }

  static isNotBlank(val: unknown): boolean {
    return !StringUtils.isBlank(val);
  }

  static isNoneBlank(...vals: Array<unknown>): boolean {
    const hasBlanks = vals.some(StringUtils.isBlank);

    return hasBlanks === false;
  }

  static isString(val: unknown): val is string {
    return typeof val === 'string';
  }

  static retirerAccentsDiacritics(text: unknown): string | null {
    if (StringUtils.isString(text)) {
      return text
        .normalize(Unicodes.NORMALIZATIONS.CANON_DECOMP)
        .replace(Unicodes.DIACRITIC_BLOCK_PROPERTY_PATTERN, '');
    }

    return null;
  }
}
